var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
export const API_TIMEOUT = 600000 * 1.01;
export const BASE_HEADERS = {
    "Content-Type": "application/json",
};
export const selectSessionToken = (state) => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.session) === null || _a === void 0 ? void 0 : _a.credentials) === null || _b === void 0 ? void 0 : _b.token; };
export const selectActiveSupervisors = (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.supervisors) === null || _a === void 0 ? void 0 : _a.activeSupervisors; };
export function prepareParams(options) {
    const params = {};
    if (options != null) {
        for (const key in options) {
            if (options[key]) {
                params[key] = JSON.stringify(options[key]);
            }
        }
    }
    return params;
}
export class BaseService {
    constructor() {
        this.controllerName = "default";
        this.apiTimeOut = API_TIMEOUT;
        this.handleExpiredToken = (error) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const store = (_a = window.appEnv) === null || _a === void 0 ? void 0 : _a.store;
            const refreshToken = (_b = window.appEnv) === null || _b === void 0 ? void 0 : _b.refreshToken;
            if (error.response.status === 401) {
                try {
                    yield store.dispatch(refreshToken(true));
                    const originalRequest = error.config;
                    const token = selectSessionToken(store.getState());
                    originalRequest.headers["Authorization"] = `Bearer ${token}`;
                    return this.api.request(originalRequest);
                }
                catch (err) {
                    console.error(err);
                }
            }
            if (error.response.status === 403) {
                error.message = "User is deactivated.";
            }
            return Promise.reject(error);
        });
    }
    get api() {
        var _a;
        if (this._api == null || this.baseUrl == null) {
            this.baseUrl = (_a = window.appEnv) === null || _a === void 0 ? void 0 : _a.baseUrl;
            if (this.baseUrl == null) {
                console.warn("Your REACT_APP_API_BASE_URL is not defined, make sure it is correctly set in .env");
            }
            this._api = axios.create({
                timeout: this.apiTimeOut,
                headers: BASE_HEADERS,
                baseURL: `${this.baseUrl}`,
            });
            this._api.interceptors.response.use(undefined, this.handleExpiredToken);
        }
        return this._api;
    }
    getDefaultHeaders() {
        var _a;
        const store = (_a = window.appEnv) === null || _a === void 0 ? void 0 : _a.store;
        if (store == null) {
            console.warn("You are using a subclass of BaseService, it requires your redux store to be exposed in window.appEnv.store but it doesn't seem to exist. Please make sure to expose your redux store there.");
            return;
        }
        const token = selectSessionToken(store.getState());
        const activeSupervisors = selectActiveSupervisors(store.getState());
        let defaultHeaders = Object.assign({}, BASE_HEADERS);
        if (token) {
            defaultHeaders = Object.assign(Object.assign({}, defaultHeaders), { Authorization: `Bearer ${token}` });
        }
        if (activeSupervisors && activeSupervisors.length > 0) {
            defaultHeaders = Object.assign(Object.assign({}, defaultHeaders), { "supervisors-identifiers": activeSupervisors
                    .map(({ id }) => id)
                    .toString() });
        }
        return defaultHeaders;
    }
    getAll(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}`, { params });
            return data;
        });
    }
    getById(id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}/${id}`, { params });
            return data;
        });
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}`);
            return data;
        });
    }
    update(id, bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.put(`/${this.controllerName}/${id}`, JSON.stringify(bodyData));
            return data;
        });
    }
    patch(id, bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.patch(`/${this.controllerName}/${id}`, JSON.stringify(bodyData));
            return data;
        });
    }
    create(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`/${this.controllerName}`, JSON.stringify(bodyData));
            return data;
        });
    }
    createUser(bodyData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`${this.controllerName}/create`, JSON.stringify(bodyData));
            return data;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.delete(`/${this.controllerName}/${id}`);
            return data;
        });
    }
}
//# sourceMappingURL=baseService.js.map